var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"d-inline-block",class:{ 'mr-2': _vm.content },domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.icon)?_c('div',{staticClass:"d-inline-block",domProps:{"innerHTML":_vm._s(_vm.icon)},on:{"click":_vm.onClick}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }